(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('InitSetupV2Controller', InitSetupV2Controller);

    InitSetupV2Controller.$inject = ['$rootScope', '$scope', 'WizardHandler', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'WizardService', 'ServiceCategoryCustom', 'CompanyCustom', 'UserProfileQuery', 'ActivityTypeInfoCustom', '$stateParams', 'CompanyInfoQuery', 'entity', 'UserCustom'];

    function InitSetupV2Controller($rootScope, $scope, WizardHandler, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, WizardService, ServiceCategoryCustom, CompanyCustom, UserProfileQuery, ActivityTypeInfoCustom, $stateParams, CompanyInfoQuery, entity, UserCustom) {
        var vm = this;
        vm.entity = entity;
        vm.wizardData;
        vm.isCompanyInfoValid = false;
        vm.isScheduleInfoValid = false;
        vm.isServiceItemValid = false;
        vm.isBusy = false;
        vm.initWizardData = initWizardData;
        vm.saveWizardData = saveWizardData;
        vm.nextFromStep = nextFromStep;
        vm.isStepValid = isStepValid;
        vm.prevFromStep = prevFromStep;
        vm.initWizardData();
        vm.setScheduleInfoValid = function setScheduleInfoValid(isvalid) {
            vm.isScheduleInfoValid = isvalid;
        }
        vm.setCompanyInfoValid = function setCompanyInfoValid(isvalid) {
            vm.isCompanyInfoValid = isvalid;
        }
        vm.setServiceItemValid = function setServiceItemValid(isvalid) {
            vm.isServiceItemValid = isvalid;
        }

        vm.getCurrentStepNumber = getCurrentStepNumber;
        vm.getStepTitle = getStepTitle;
        vm.goToDashboard = goToDashboard;
        vm.isWorkSpace = false;
        vm.isResetMode = false;
        vm.userInsight;


        loadData();


        function loadData() {

            if (vm.entity && vm.entity.resetMode)
                vm.isResetMode = vm.entity.resetMode;
            checkCurrentCompany();
            getCurrentUser();
        }

        function getCurrentUser() {
            UserProfileQuery.getCurrentPersonInfo().query(function (p) {
                vm.personInfo = p;
            });
        }


        function checkCurrentCompany() {
            CompanyInfoQuery.getCurrentCompanyInfo().query(function (c) {
                if (c && c.title && !vm.isResetMode)
                    $state.go('supplierPanel-v2.dashboard');
            })
        }


        $rootScope.$broadcast('hideNavBar');

        function nextFromStep() {

            var wizard = WizardHandler.wizard();
            var currentStep = wizard.currentStepNumber();
            if (vm.isStepValid(currentStep)) {
                //end step
                if (currentStep == 3) {
                    vm.saveWizardData(function (savedDate) {
                        vm.wizardData = savedDate;
                        vm.isBusy = false;
                        addGTagData();
                        wizard.next();
                        Principal.setCurrentCompany(vm.wizardData.company);
                    }, function (error) {
                        vm.isBusy = false;
                    });
                } else {
                    wizard.next();
                }
            }
        }

        function prevFromStep() {
            var wizard = WizardHandler.wizard();
            wizard.previous();
        }

        function isStepValid(stepNumber) {
            switch (stepNumber) {
                case 1:
                    return vm.isCompanyInfoValid;
                case 2:
                    return vm.isScheduleInfoValid;
                case 3:
                    return vm.isServiceItemValid;
            }

        }

        function initWizardData() {

            vm.wizardData = {};
            vm.wizardData.serviceItem = {};
            vm.wizardData.serviceItems = [];
            vm.wizardData.serviceItems.push(vm.wizardData.serviceItem);
            vm.wizardData.newServant = {};
            vm.wizardData.newServant.personInfo = {};
            vm.wizardData.newServant.personInfo.fisrtName = null;

        }

        function collectWizardData() {
            vm.wizardData.serviceItems[0] = vm.wizardData.serviceItem;
        }

        function saveWizardData(onSuccess, onFail) {
            vm.isBusy = true;
            collectWizardData();

            //update user insight data
            UserCustom.updateUserInsight().update(vm.userInsight)
            return WizardService.saveInitSetup().save(vm.wizardData, onSuccess, onFail);

        }


        function SetDataByActivityType() {

            if (vm.wizardData.company == null || vm.wizardData.company == undefined || !vm.wizardData.company.activityType)
                return;

            ActivityTypeInfoCustom.getActivityTypeInfoByType(vm.wizardData.company.activityType).query(function (activity) {
                vm.activityTypeInfo = activity;
                if (activity && activity.servantType == "RESOURCE") {
                    vm.isWorkSpace = true;
                    vm.wizardData.serviceItem.itemTitle = vm.activityTypeInfo.serviceSamplePlaceHolder;
                    vm.wizardData.serviceItem.duration = 60;
                    vm.wizardData.serviceItem.minPrice = 0.0;

                    vm.wizardData.newServant = {};
                    vm.wizardData.newServant.personInfo = {};
                    vm.wizardData.newServant.personInfo.fisrtName = vm.activityTypeInfo.servantTitle + ' شماره 1 ';
                    vm.wizardData.newServant.personInfo.lastname = ' ';
                } else {
                    vm.isWorkSpace = false;
                    vm.wizardData.serviceItem.itemTitle = vm.activityTypeInfo.serviceSamplePlaceHolder;
                    vm.wizardData.serviceItem.duration = 60;
                    vm.wizardData.serviceItem.minPrice = 100000.0;

                    // vm.wizardData.serviceItem = {};
                    vm.wizardData.newServant = {};
                    vm.wizardData.newServant.personInfo = vm.personInfo;
                }

            })

        }

        function addGTagData() {


            var activityType = 'NOT_SET';
            if (vm.wizardData.company && vm.wizardData.company.activityType) {
                activityType = vm.wizardData.company.activityType;
            }

            try {
                //user Free Account Started
                if (gtag()) {
                    gtag('event', 'freemium_start', {
                        "items": [
                            {
                                "id": "PL102",
                                "name": "14 Days Free Account",
                                "list_name": "",
                                "brand": "Planovin",
                                "category": vm.wizardData.company.activityType,
                                "price": '0'
                            }
                        ]
                    });
                }
            } catch (err) {
                console.log(err);
            }
        }

        function getCurrentStepNumber() {
            var wizard = WizardHandler.wizard();
            return wizard.currentStepNumber();
        }

        function getStepTitle(stepNumber) {
            if (getCurrentStepNumber() == stepNumber) {
                switch (stepNumber) {
                    case 1 :
                        return 'wizard.initsetup.step1';
                    case 2 :
                        return 'wizard.initsetup.step2';
                    case 3 :
                        return 'wizard.initsetup.step3';
                    case 4 :
                        return 'wizard.initsetup.step4';
                }
            }
        }

        function goToDashboard() {
            $rootScope.$broadcast('reloadNavBarData');
            $state.go('supplierPanel-v2.dashboard');
        }

        $scope.$watch('vm.wizardData.company.activityType', function () {
            SetDataByActivityType();
        });


    }
})();
